import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Form, Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import api from '~/services/api';
import { storeData, updateData } from '~/store/modules/perfis/actions';

import Tree from '../Tree';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const [itens, setItens] = React.useState([]);
  const [perfis, setPerfis] = React.useState([]);

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.perfis);

  const [loadingModule, setLoadingModule] = useState(false);

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        nomeperfil: Yup.string().required('s.geral.validacao.campoobrigatorio'),
        statusperfil: Yup.string()
          .nullable()
          .required('s.geral.validacao.campoobrigatorio'),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idcliente: client,
        itens,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const handleGetPerfis = React.useCallback(async () => {
    try {
      if (create) {
        setLoadingModule(true);
        const response = await api.get('perfis/0', {
          params: { pesquisalista: true },
        });

        setPerfis(response.data.itens);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoadingModule(false);
    }
  }, []);

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  useEffect(() => {
    handleGetPerfis();
  }, []);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="nomeperfil"
            label={t('s.cadastro..usuario.perfil.nomeperfil')}
          />

          <Select
            name="statusperfil"
            label={t('s.cadastro..usuario.perfil.statusperfil')}
            options={[
              { value: 'L', label: t('s.geral.opcoes.liberado') },
              { value: 'B', label: t('s.geral.opcoes.bloqueado') },
              { value: 'C', label: t('s.geral.opcoes.cancelado') },
            ]}
          />
          {/* ({JSON.stringify(create ? perfis : isArray(initials.itens) ? initials.itens : [])}) */}

          <Tree
            items={
              create ? perfis : isArray(initials.itens) ? initials.itens : []
            }
            onSelecteds={(values) => setItens(values)}
            edition={!create}
            loading={loadingModule}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
